import React from "react";

import { ShadeSelector } from "../../ShadeSelector/ShadeSelector";

import { verticalProductCardColorSwatchWrapper } from "./VerticalProductCard.css";
import type { ProductCardDataType } from "./types";

type Props = {
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  product: Pick<ProductCardDataType, "swatchImages" | "variationName">;
  visibleItemCount?: number;
};

export const VerticalProductCardColorSwatch: React.FC<Props> = ({
  onClick,
  product,
  visibleItemCount = 4
}) => {
  if (!product.swatchImages?.length) return null;

  const title = product.variationName || "Select shade";

  const handleClick = onClick
    ? (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        event.stopPropagation();
        onClick(event);
      }
    : undefined;

  return (
    <div className={verticalProductCardColorSwatchWrapper}>
      <ShadeSelector
        title={title}
        shades={product.swatchImages}
        previewCount={visibleItemCount}
        onClick={handleClick}
        dataTestId="vertical-product-card-colour-swatch"
        showShadow={false}
      />
    </div>
  );
};
